/* @flow */
import React from 'react';
import RequireUser from 'components/mixins/RequireUser';
import { markAccountCreationStart } from 'utils/accountCompletionTracker';
import CurrentUser from 'auth/CurrentUser';

import './styles/SetupView.scss';

const SetupView = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    RequireUser,
  ],

  componentDidMount() {
    markAccountCreationStart(CurrentUser.getUser());
  },

  render() {
    return (
      <div className="SetupView">
        {this.props.children}
      </div>
    );
  },
});

export default SetupView;



// WEBPACK FOOTER //
// ./src/setup/components/SetupView.jsx